import './kutejs-polyfill'
import KUTE from "kute.js";

(function(jQuery) {
  jQuery(document).ready(($) => {
    // Toggle navbar-icon
    // todo: do this with css only
    const $nav = $('aside.sidebar nav');
    const $navToggler = $('.navbar-toggler');
    const $window = $(window)
    $navToggler.on('click', function () {
      if ($(this).hasClass("is-active")) {
        // we use kutejs to animate the nav-toggle
        KUTE.fromTo('#circle',
          {path: '#circle' },
          { path: '#circle-1' },
          {  duration: 300}
          ).start();
        $nav.animate({'height': "0"}, 300, function () {
          $(this).hide();
        });
      } else {
        KUTE.fromTo('#circle',
          {path: '#circle' },
          { path: '#cross' },
          { duration: 300}
          ).start();

        $nav.show().animate({'height': "100%"}, 300, function () {
        });
      }
      $(this).toggleClass('is-active')
    });

    // trigger portfolio navigation on mobile devices
    $("li[id^=\"menu-item-\"] > .portfolio-cat").on("click", function() {
      if($window.width() < 768) {
        $navToggler.trigger('click');
      }
    })

    // switch navigation between mobile and desktop
    // todo: css only
    $window.on('resize', () => {
      // close sidebar on resize
      if ($window.innerWidth > 768) {
        $nav.css({"height": "", "display": ""});
        $navToggler.removeClass("is-active")
      }
    });
  });
})(jQuery)
